// @flow
import styled from 'styled-components';
import { paleBlue, g200, g400 } from '../../colors';
/*::
import type { Node } from 'react';

export type TabsThemeType = {|
  Main: * => Node,
  List: * => Node,
  ScrollContainer: * => Node,
  ScrollLeft: * => Node,
  ScrollRight: * => Node,
|};
*/

var thm
/*: TabsThemeType */
= {
  // default theme
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1t40caj-0"
  })(["width:", ";display:flex;flex-direction:column;align-items:center;"], function (pr) {
    return pr.scrollable ? '100%' : 'auto';
  }),
  List: styled.div.withConfig({
    displayName: "theme__List",
    componentId: "sc-1t40caj-1"
  })(["width:", ";overflow-x:", ";display:flex;font-weight:300;flex-direction:row;border:1px solid ", ";padding:0.8rem;border-radius:3rem;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}@-moz-document url-prefix(){&{overflow-x:scroll;}}"], function (pr) {
    return pr.scrollable ? '100%' : 'auto';
  }, function (pr) {
    return pr.scrollable ? 'scroll' : 'auto';
  }, paleBlue()),
  ScrollContainer: styled.div.withConfig({
    displayName: "theme__ScrollContainer",
    componentId: "sc-1t40caj-2"
  })(["width:", ";position:relative;"], function (pr) {
    return pr.scrollable ? '100%' : 'auto';
  }),
  ScrollLeft: styled.div.withConfig({
    displayName: "theme__ScrollLeft",
    componentId: "sc-1t40caj-3"
  })(["position:absolute;left:0;top:50%;border-radius:3rem;height:0;width:0;border-left:3px solid ", ";background:linear-gradient(90deg,", ",transparent);cursor:pointer;transition:width 1s,height 1s,top 1s;"], g400(), g200()),
  ScrollRight: styled.div.withConfig({
    displayName: "theme__ScrollRight",
    componentId: "sc-1t40caj-4"
  })(["position:absolute;right:0;top:0;border-radius:3rem;height:100%;width:5rem;border-right:3px solid ", ";background:linear-gradient(-90deg,", ",transparent);cursor:pointer;transition:width 1s,height 1s,top 1s;"], g400(), g200())
};
export default thm;